<template>
  <div class="image-container">
    <img
      class="background-image"
      :src="'/dashboard/images/integrations/scan.png'"
      alt="Background"
    />
    <img
      class="qr-code"
      width="180"
      height="180"
      :src="base64Image"
      alt="QR Code"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  computed: {
    base64Image() {
      return this.data;
    },
  },
};
</script>

<style>
.image-container {
  position: relative;
  width: 180px;
  height: 180px;
}

.background-image {
  display: block;
  width: 180px;
  height: 180px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>
